import lodash from "lodash";
import { reactive, toRaw, defineAsyncComponent } from "vue";
import { notification } from "ant-design-vue";
import i18n from "../../../../i18n";
import store from "../../../../store";

export const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

import { onClickActiveAll, onClickArchiveAll, onClickDeleteAll, onClickEdit, onClickView } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import {
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView,
} from "../../../../utils/page";

import { flatWhereGroup } from "../../../../utils/search";
import { validateError } from "../../../../utils/validate";

import { createConditionAction } from "./request.condition";
import { createColumns } from "./request.section";

import { createForm as createFormAddress } from "../../../../components/address/address.logic";
import { has, have } from "../../../../utils/menu-context";
import { createForm as createFormVesselRequest } from "../vessel/vessel.logic";

export const { isLoading, setIsLoading } = createLoading();
export const actionPrefix = "resource/v1/transaction/licenseRequest";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });

export const callAssignTo = ({ licenseRequestIds, assignToUserId }) =>
    store.dispatch(`resource/v1/transaction/bookLicenseRequest/assignTo`, { licenseRequestIds, assignToUserId });

export const callRequestLicenseAll = ({ data }) => store.dispatch(`${actionPrefix}/requestLicenseAll`, { data });

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then((page) => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**", "refRequester.**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props })],
            children: [
                {
                    name: "addresses",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refId", type: "UUID", operator: "=", value: id }, { name: "model", type: "String", operator: "=", value: "LicenseRequest" }],
                },
                {
                    name: "refVesselRequest.vesselOwnerRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
                {
                    name: "fishingToolRequests",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [],
                },
            ],
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: [],
        };
    }
};

export const distinct = (value, index ,self) => {
    return self.indexOf(value) == index;
}

export const createWhereFor = ({ props, menuContextRequest }) => {
    const whereAll = [];
    const menuContext = menuContextRequest || props.menuContext;
    const userInfo = store.state.resource.auth.info?.user;

    const userDepartment = store.state.resource.auth.info?.department;
    const whereGroup = [];


    /* Control การมองเห็นตามสิทธิ์  */
    // เห็นทั้งหมด
    const isOfficer = has({ menuContext, key: "forReviewRequest"})
        || has({ menuContext, key: "forLawyerAuditor"})
        || has({ menuContext, key: "forRDAuditor"})
        || has({ menuContext, key: "forDofCenter"})
        || has({ menuContext, key: "forAuthorized"})
    
    if (!has({ menuContext, key: "viewOnlyInProvince"})
        && !has({ menuContext, key: "viewOnlyInAmphur" })
        && isOfficer
    ) {
        console.log(""); // ห้ามลบ !!!!!!!! 
    }
    // เห็นแค่ในจังหวัดและอำเภอภายในจังหวัด โดยเทียบข้อมูลในคำขอ ส่วนของหน่วยรับคำขอ ที่ตรงกับสังกัดของเจ้าหน้าที่ และสังกัดลูกของเจ้าหน้าที่
    else if (has({ menuContext, key: "viewOnlyInProvince" }) && isOfficer) {
        whereGroup.push([{ name: "refReceiveDept.refProvince.id", type: "UUID", operator: "=", value: userDepartment?.refProvince?.id }])
    }
    // เห็นแค่ในจังหวัด โดยเทียบข้อมูลในคำขอ ส่วนของหน่วยรับคำขอ ที่ตรงกับสังกัดของเจ้าหน้าที่
    else if (has({ menuContext, key: "viewOnlyInAmphur" }) && isOfficer) {
        whereGroup.push([{ name: "refReceiveDept.id", type: "UUID", operator: "=", value: userInfo?.refSubDepartment?.id }])
    }
    // เห็นได้เฉพาะที่ตัวเองสร้าง
    else if (has({ menuContext, key: "viewOnlyMe" }) && !isOfficer) {
        whereGroup.push([{ name: "createBy", type: "String", operator: "=", value: userInfo.username }]);
    }

    // Control การมองเห็นตาม status เฉพาะของเจ้าหน้าที่
    const officerSeeOnStatus = [];
    if (isOfficer) {
        if (has({ menuContext, key: "forSendRequest" })) {
            officerSeeOnStatus.push("draft");
        }
        if (has({ menuContext, key: "forReviewRequest" })) {
            officerSeeOnStatus.push("waitAcceptRequest");
            officerSeeOnStatus.push("waitModify");
            officerSeeOnStatus.push("waitRDAudit");
            officerSeeOnStatus.push("waitLawyerAudit");
            officerSeeOnStatus.push("waitArgueLawyer");
            officerSeeOnStatus.push("waitDofCenterAudit");
            officerSeeOnStatus.push("waitApprove");
        }
        if (has({ menuContext, key: "forRDAuditor" })) {
            officerSeeOnStatus.push("waitRDAudit");
            officerSeeOnStatus.push("waitDofCenterAudit");
            officerSeeOnStatus.push("waitApprove");
        }
        if (has({ menuContext, key: "forLawyerAuditor" })) {
            officerSeeOnStatus.push("waitLawyerAudit");
            officerSeeOnStatus.push("waitArgueLawyer");
            officerSeeOnStatus.push("waitDofCenterAudit");
            officerSeeOnStatus.push("waitApprove");
            whereGroup.push([
                { name: "updateBy", type: "String", operator: "=", value: userInfo.username },
                { logic: "OR", name: "refStatus.key", type: "String", operator: "in", value: officerSeeOnStatus }
            ]);
        }
        if (has({ menuContext, key: "forDofCenter" })) {
            officerSeeOnStatus.push("draft");
            officerSeeOnStatus.push("waitModify");
            officerSeeOnStatus.push("waitArgueLawyer");
            officerSeeOnStatus.push("cancel");
            officerSeeOnStatus.push("waitAcceptRequest");
            officerSeeOnStatus.push("waitRDAudit");
            officerSeeOnStatus.push("waitLawyerAudit");
            officerSeeOnStatus.push("waitDofCenterAudit");
            officerSeeOnStatus.push("waitApprove");
            officerSeeOnStatus.push("notApprove");
            officerSeeOnStatus.push("appeal");
        }
        if (has({ menuContext, key: "forAuthorized" })) {
            officerSeeOnStatus.push("waitApprove");
        }
        officerSeeOnStatus.filter(distinct)
        officerSeeOnStatus.push("notApprove", "approve", "cancel", "appeal")
        if (!has({ menuContext, key: "forLawyerAuditor" })) {
            whereAll.push({ name: "refStatus.key", type: "String", operator: "in", value: officerSeeOnStatus })
        }
    }
    whereAll.push(...flatWhereGroup({ where: whereGroup, logic: "OR" }))
    return whereAll;
};

export const createForm = () => {
    return {
        refRequestType: null,
        isTemp: null,
        requestCode: null,
        licenseCode: null,
        approveDate: null,
        requestDate: null,
        expiryDate: null,
        refReceiveDept: null,
        refStatus: null,
        refUserCreate: null,
        refRequester: null,
        requesterIdCard: null,
        refRequesterCompanyType: null,
        refRequesterTitle: null,
        requesterFirstName: null,
        requesterLastName: null,
        requesterAge: null,
        isAttorney: null,
        refAttorneyTitle: null,
        attorneyFirstName: null,
        attorneyLastName: null,
        attorneyIdCard: null,
        attorneyPhoneNumber: null,
        refFishingArea: null,
        isThaiWorkers: null,
        totalThaiWorkers: null,
        thaiMaleWorkers: null,
        thaiFemaleWorkers: null,
        isForeignWorkers: null,
        totalForeignWorkers: null,
        foreignMaleWorkers: null,
        foreignFemaleWorkers: null,
        refFisheriesOfficerStatus: null,
        fisheriesOfficerRemark: null,
        expireDateToEdit: null,
        refLawyerStatus: null,
        lawyerRemark: null,
        refDofCenterStatus: null,
        dofCenterRemark: null,
        refDirectorStatus: null,
        directorRemark: null,
        isHaveAppealedRequest: null, isHaveAppealedLicense: null,
        isSubstitute: null,
        refVesselRequest: createFormVesselRequest(),
        isOfficerCreate: null,
        fishingToolRequests: [],
        children: [],
        addresses: [createFormAddress({model: "LicenseRequest"})],
        attachments: [],
        attachmentReviewRequests: [],
        attachmentLawyers: [],
        attachmentDofCenters: [],
        attachmentDirectors: [],
    };
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id ? `${modelRef.refRequestType?.value} (${modelRef.refStatus?.value})` : i18n.global.t("button.create");
};

export const initState = ({ props, data }) => {
    const { menuContext, routerPrefix } = props;
    const user = store.state.resource.auth.info?.user;
    state.columns = createColumns({props, data});
    state.manages = [
        createManageSelect({
            menuContext,
        }),
        {
            icon: () => <CIcon file="book.svg"></CIcon>,
            text: () => i18n.global.t("button.bookingRequest"),
            force: false,
            visible: () => has({ menuContext: menuContext, key: "canSelect" }),
            rowSelection: true,
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map((d) => d.name).join(", ") }),
            buttonProp: { class: "btn-primary" },
            getCheckboxProps: ({ record }) => {
                // return ({ disabled: (record.isActive === false || checkBook?.refLicenseRequest?.id === record?.id) && record.refStatus?.key == 'waitDofCenterAudit'  })
                  const { menuContext } = props;
                  if (record.refStatus?.attribute?.canActionAttribute) {
                      let checkBook = record.bookLicenseRequests?.find(bookData => (bookData.refStatus.id == record.refStatus.id))
                      const isNotCanActionOnRequestStatus = !have({menuContext, key: record.refStatus?.attribute?.canActionAttribute })
                      return ({ disabled: (record.isActive === false || checkBook?.refLicenseRequest?.id === record?.id || isNotCanActionOnRequestStatus)  })
                  } else {
                      return ({ disabled: true })
                  }
            },
            onClick: ({ rowSelection }) => {
                setIsLoading(true);
                return callAssignTo({ licenseRequestIds: rowSelection?.selectedRowKeys, assignToUserId: user.id })
                    .then(() => notification["success"]({ message: i18n.global.t(`views.request.licenseRequest.bookingRequestSuccess`) }))
                    .then(() => onSearch({ props, page: state.page, state }))
                    .finally(() => setIsLoading(false));
            },
        },
        {
            icon: () => <CIcon file="book.svg"></CIcon>,
            text: () => i18n.global.t("button.approveRequestAll"),
            force: false,
            visible: () => has({ menuContext, key: "forAuthorized" }),
            rowSelection: true,
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map((d) => d.name).join(", ") }),
            buttonProp: { class: "btn-primary" },
            getCheckboxProps: ({ record }) => {
                const canApprove = ({ disabled: true })
                if (record.refStatus?.key == 'waitApprove') {
                    canApprove.disabled = false;
                }
                return canApprove;
            },
            onClick: ({ rowSelection }) => {
                setIsLoading(true);
                const data = rowSelection.selectedRows.map(row => {
                    return  { licenseRequest: {...row }, otp: null, isSendRequest: true, isApproveAllRequest: true }
                })
                return callRequestLicenseAll({ data })
                    .then(() => notification["success"]({ message: i18n.global.t(`views.request.licenseRequest.approveRequestAll`) }))
                    .then(() => onSearch({ props, page: state.page, state }))
                    .finally(() => setIsLoading(false));
            },
        },
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: (search) => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map((d) => d.draftCode).join(", ") }),
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: (search) => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map((d) => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canArchive({ props, record }) }),
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: (search) => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map((d) => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canDelete({ props, record }) }),
        }),
        createManageExportCsv({ menuContext }),
    ];
    state.manageExtras = [];
    state.rowActions = [
        createRowActionView({
            menuContext,
            onClick: ({ record }) => {
                let routerPrefixform = routerPrefix;
                if ("changeLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `change-${routerPrefix}`;
                } else if ("requestReplacement".includes(record.refRequestType.key)) {
                    routerPrefixform = `replacement-${routerPrefix}`;
                } else if ("cancelLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `cancel-${routerPrefix}`;
                } else if ("transferLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `transfer-${routerPrefix}`;
                } else if ("renewLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `renew-${routerPrefix}`;
                }
                onClickView({ record,  routerPrefix: routerPrefixform });
            },
        }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => {
                let routerPrefixform = routerPrefix;
                if ("changeLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `change-${routerPrefix}`;
                } else if ("requestReplacement".includes(record.refRequestType.key)) {
                    routerPrefixform = `replacement-${routerPrefix}`;
                } else if ("cancelLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `cancel-${routerPrefix}`;
                } else if ("transferLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `transfer-${routerPrefix}`;
                } else if ("renewLicense".includes(record.refRequestType.key)) {
                    routerPrefixform = `renew-${routerPrefix}`;
                }
                onClickEdit({ record, routerPrefix: routerPrefixform });
            },
            visible: ({ record }) => state.conditionAction.canEdit({ props, record }),
        }),
    ];
};

export const state = reactive({
    // columns: createColumns(),
    columns: [],
    page: createPage({
        options: {
            select: ["**", "refReceiveDept.*", "refStatus.attribute"],
            children: [{
                name: 'bookLicenseRequests',
                select: ['**', 'refBookBy.**'],
                page: 0,
                size: 1000000
            }],
            isDistinct: false,
            sort: [{ name: "draftCode", type: "DESC" }],
        },
    }),
    tableOptions: { search: { activeKey: null } },
    conditionAction: createConditionAction(),
});
